<template>
  <div class="details">
    <div class="details-dv">
      <div class="details-dvh">
        <!-- <img src="../../assets/bg-xiangqing-lv.png" alt=""> -->
        <h1>问卷详情</h1>
      </div>
    </div>
    <div class="details-dv1">
      <h3>{{ name }}</h3>
      <div v-for="(item, io) in listdata" :key="io">
        <ul>
          <li>
            <div class="title_tex" v-if="item.title !== ''">
              <div class="bi" v-if="item.required" />
              <div class="biaoti" />
              <span>{{ item.title }}</span>
            </div>
            <!-- 单选 -->
            <form action="" method="get" v-if="item.type == 'gradeRadio'">
              <label
                v-for="(vo, index) in item.items"
                :key="index"
                class="aaalable"
              >
                <div :class="{ activespan1: vo.answer }" />
                <span>{{ vo.text }}</span>
              </label>
            </form>
            <!--   多选 -->
            <form action="" method="get" v-if="item.type == 'gradeCheckbox'">
              <label
                v-for="(co, index) in item.items"
                :key="index"
                class="aaalable"
              >
                <!-- <img src="../../assets/duihao1.png" alt="" v-if="co.answer "> -->
                <span class="duihao1" v-if="co.answer" />
                <i :class="{ activespan2: co.answer }" />
                <span>{{ co.text }}</span>
              </label>
            </form>
            <textarea
              placeholder="请填写这里..."
              cols="39"
              rows="6"
              v-if="item.type == 'baseTextArea' || item.type == 'baseRemark'"
              class="text_area"
              v-model="item.answer"
            />

            <input
              placeholder="请填写这里..."
              v-if="
                item.type == 'baseText' ||
                  item.type == 'name' ||
                  item.type == 'phone' ||
                  item.type == 'academy' ||
                  item.type == 'specialty' ||
                  item.type == 'industry' ||
                  item.type == 'profession'
              "
              class="text_area1"
              v-model="item.answer"
            />

            <input
              placeholder="请填写这里..."
              v-if="item.type == 'email'"
              class="text_area1"
              type="email"
              v-model="item.answer"
            />

            <input
              placeholder="请填写这里..."
              v-if="item.type == 'sex'"
              class="text_area1"
              type="email"
              v-model="sexstext"
            />

            <p
              v-if="item.type == 'uploadFile' && item.desc !== ''"
              class="filenameCls"
            >
              {{ item.desc }}
            </p>

            <div class="lplplp" v-if="item.type == 'matrixGauge'">
              <table
                cellspacing="1"
                cellpadding="1"
                border="1"
                class="el-table browsersupport"
              >
                <tr>
                  <th />
                  <th>{{ item.endDesc }}</th>
                  <th v-for="(items, y) in item.itemNum - 2" :key="y">
                    {{ items + 1 }}
                  </th>
                  <th>{{ item.startDesc }}</th>
                </tr>
                <tr v-for="(vo, voinde) in item.rowDesc" :key="voinde">
                  <td>
                    {{ vo.text }}
                  </td>
                  <td
                    v-for="(items, itemsindex) in item.itemNum"
                    :key="itemsindex"
                  >
                    <span
                      :class="{ activespan: itemsindex + 1 == vo.selectNum }"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div class="lplplp" v-if="item.type == 'baseGauge'">
              <table
                cellspacing="1"
                cellpadding="1"
                border="1"
                class="el-table1 browsersupport"
              >
                <tr>
                  <th>{{ item.endDesc }}</th>
                  <th v-for="(items, y) in item.itemNum - 2" :key="y">
                    {{ items + 1 }}
                  </th>
                  <th>{{ item.startDesc }}</th>
                </tr>
                <tr>
                  <td
                    v-for="(items, itemsindex) in item.itemNum"
                    :key="itemsindex"
                  >
                    <span
                      :class="{ activespan: itemsindex + 1 == item.selectNum }"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="MyQuestionaire-dv3" @click="jumpMyquest">
      <!-- <img src="../../assets/back.png" /> -->
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  data() {
    return {
      arrlist: [],
      textarea: "",
      inputval: "",
      danxuan: "",
      filename: "",
      showradius: false,
      showradius1: true,
      isActive: -1,
      isActivespan: -1,
      isindex: "",
      baseindex: -1,
      sexstext: "",
      name: this.$route.query.names,
      listdata: []
    };
  },
  methods: {
    jumpMyquest() {
      this.$router.push({ path: "/MyQuestionaire", query: { index: 1 } });
    },
    queryQuestionAll() {
      let key = {
        formId: this.$route.query.formId,
        userId: JSON.parse(localStorage.getItem("userInfo")).sysUserId
      };
      this.$post(api.questionnaire.AnswerAll(), key).then(res => {
        this.listdata = res.data.questions || [];
        this.listdata.forEach(item => {
          if (item.type == "sex") {
            item.items.forEach(vo => {
              if (vo.answer) {
                this.sexstext = vo.text;
              }
            });
          }
        });
      });
    }
  },
  mounted() {
    this.queryQuestionAll();
  }
};
</script>

<style lang="scss" scoped>
.details {
  .details-dv {
    .details-dvh {
      width: 100%;
      height: 140px;
      background: url("../../assets/bg-xiangqing-lv.png") no-repeat center
        center;
      background-size: 100% 100%;

      h1 {
        position: absolute;
        left: 50%;
        top: 55px;
        transform: translate(-50%, -50%);
        font-size: 36px;
        font-family: PingFangSC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 5px;
      }

      img {
        width: 100%;
        height: 140px;
      }
    }
  }

  .details-dv1 {
    position: absolute;
    top: 110px;
    background: rgba(255, 255, 255, 1);
    box-shadow: $box-shadow;
    border-radius: 40px 40px 0px 0px;
    width: 100%;
    height: 100%;
    .lplplp {
      margin-top: 20px;
      margin-bottom: 60px;
      display: flex;
      overflow-x: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      margin-bottom: 40px;
      &::-webkit-scrollbar {
        width: 0 !important;
        height: 0 !important;
      }
    }
    .aaalable {
      display: block;
      margin-left: 45px;
      margin-top: 10px;
      margin-bottom: 20px;
      position: relative;

      img {
        width: 28px;
        height: 18px;
        position: absolute;
        left: 4px;
        top: 15px;
      }
      .duihao1 {
        width: 28px;
        height: 18px;
        position: absolute;
        left: -16px;
        top: 15px;
        background: url("../../assets/duihao1.png") no-repeat center center;
        background-size: 100% 100%;
      }
      input {
        float: left;
        width: 34px;
        height: 34px;
      }

      div {
        width: 34px;
        height: 34px;
        border: 2px solid rgba(221, 221, 221, 1);
        border-radius: 50%;
        display: inline-block;
        // float: left;
        margin-top: 8px;
      }

      i {
        width: 34px;
        height: 34px;
        border: 2px solid rgba(221, 221, 221, 1);
        // float: left;
        margin-top: 8px;
        display: inline-block;
      }

      .activespan1 {
        border: 8px solid rgba(3, 177, 135, 1);
      }

      .activespan2 {
        border: 1px solid rgba(3, 177, 135, 1);
        background-color: rgba(3, 177, 135, 1);
      }

      span {
        font-size: 24px;
        font-family: PingFangSC;
        font-weight: 400;
        color: rgba(150, 150, 150, 1);
        margin-left: 20px;
      }
    }

    .el-table {
      border-collapse: collapse;
      border: 1px solid #aaa;
      margin-bottom: 50px;
      // min-width: 159.5vw;
      flex: 1;
    }
    .el-table1 {
      border-collapse: collapse;
      border: 1px solid #aaa;
      margin-bottom: 50px;
      // min-width: 173vw;
      flex: 1;
    }
    table.browsersupport th {
      min-width: 100px;
      padding: 15px 10px;
      height: 40px;
      vertical-align: middle;
      text-align: center;
      border: 1px solid #ddd;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(150, 150, 150, 1);
    }

    table.browsersupport td {
      width: 200px;
      padding: 25px 5px;
      vertical-align: middle;
      text-align: center;
      border: 1px solid #ddd;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(150, 150, 150, 1);
      text-align: center;

      span {
        width: 34px;
        height: 34px;
        border: 2px solid rgba(221, 221, 221, 1);
        border-radius: 50%;
        display: inline-block;
      }

      .activespan {
        border: 8px solid rgba(3, 177, 135, 1);
      }
    }

    h3 {
      font-size: 30px;
      font-family: PingFangSC;
      font-weight: 500;
      color: rgba(50, 50, 50, 1);
      text-align: center;
      margin-top: 39px;
      margin-bottom: 59px;
    }

    ul {
      li {
        padding-left: 51px;
        padding-right: 51px;
        position: relative;
        .title_teximg {
          position: absolute;
          left: 10px;
          top: 0;
        }
        .title_tex {
          img {
            width: 40px;
            height: 22px;
            margin-right: 10px;
            float: left;
            margin-top: 6px;
          }
          .biaoti {
            margin-top: 14px;
            float: left;
            width: 45px;
            height: 25px;
            margin-right: 15px;
            background: url("../../assets/dian-biaoti.png") no-repeat center
              center;
            background-size: 100% 100%;
          }
          .bi {
            margin-top: 14px;
            float: left;
            width: 45px;
            height: 25px;
            background: url("../../assets/bi.png") no-repeat center center;
            background-size: 100% 100%;
            position: absolute;
            left: 10px;
            top: 0;
          }
          span {
            font-size: 24px;
            font-family: PingFangSC;
            font-weight: 700;
            color: #323232;
            word-wrap: break-word;
            word-break: break-all;
            overflow: hidden;
          }
        }

        p {
          font-size: 22px;
          font-family: PingFangSC;
          font-weight: 400;
          color: rgba(150, 150, 150, 1);
          line-height: 36px;
          letter-spacing: 2px;
          margin-left: 50px;
          margin-top: 27px;
          margin-bottom: 27px;
        }

        .text_area {
          margin-bottom: 60px;
          margin-left: 50px;
          padding-top: 40px;
          padding-left: 30px;
          border: 1px solid rgba(221, 221, 221, 1);
          border-radius: 10px;
          width: 89%;
          font-size: 20px;
          color: #666;
          letter-spacing: 2px;
          margin-top: 15px;
        }
        textarea:disabled,
        input:disabled {
          background-color: #fff;
        }

        .text_area1 {
          margin-bottom: 60px;
          margin-left: 50px;
          padding-top: 20px;
          padding-bottom: 20px;
          padding-left: 30px;
          border: 1px solid rgba(221, 221, 221, 1);
          border-radius: 10px;
          width: 89%;
          font-size: 20px;
          color: #666;
          letter-spacing: 2px;
          margin-top: 15px;
        }
        .filenameCls {
          width: 90%;
          height: 100%;
          background: rgba(244, 244, 244, 1);
          border-radius: 10px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(50, 50, 50, 1);
          padding: 20px 15px;
          margin-top: 20px;
        }
        input::-webkit-input-placeholder,
        textarea::-webkit-input-placeholder {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(204, 204, 204, 1) !important;
        }
      }
    }
  }
  .MyQuestionaire-dv3 {
    width: 71px;
    height: 71px;
    background: url("../../assets/back.png") no-repeat center center;
    background-size: 100% 100%;
    position: absolute;
    position: fixed;
    bottom: 80px;
    left: 24px;
  }
}
</style>
